// src/services/api.js
import axios from 'axios';

export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000') + '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
});

// Adjuntar token JWT a cada petición automáticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Token expirado o inválido — forzar logout
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    if (err.response) {
      err.message = `HTTP ${err.response.status} ${err.response.statusText || ''}`.trim();
    } else if (err.request) {
      err.message = 'Network Error (sin respuesta del servidor)';
    } else {
      err.message = err.message || 'Error desconocido';
    }
    return Promise.reject(err);
  }
);

export default api;
